module.exports = __webpack_public_path__ + "img/Seayak.47b55940.jpg";